import { EntityState } from '@examdojo/state';
import { Enum, TableInsertModel, TableRowModel, TableUpdateModel } from '@examdojo/supabase';

export type UserHttpModel = Pick<
  TableRowModel<'users'>,
  | 'syllabus_id'
  | 'course_level'
  | 'email'
  | 'first_name'
  | 'id'
  | 'last_name'
  | 'origin'
  | 'profile_pic'
  | 'school_name'
  | 'updated_at'
  | 'created_at'
  | 'last_sign_in_at'
  | 'streak_goal'
  | 'current_onboarding_step'
  | 'profession'
  | 'program'
  | 'practice_submitted'
>;

export type OnboardingStep = Enum<'onboarding_step'>;

export type UserStoreModel = UserHttpModel;

export type UserUIModel = UserStoreModel & {
  fullName: string;
};

export interface UserState extends EntityState<UserStoreModel> {}

export const USER_CREATE_ALLOWED_KEYS = [
  'email',
  'first_name',
  'last_name',
  'profile_pic',
  'school_name',
  'onboarded_topic_practice',
  'onboarded_app',
  'origin',
  'syllabus_id',
  'course_level',
  'streak_goal',
  'current_onboarding_step',
  'profession',
  'program',
  'practice_submitted',
] satisfies Array<keyof TableInsertModel<'users'>>;

export type UserCreateModel = Pick<TableInsertModel<'users'>, (typeof USER_CREATE_ALLOWED_KEYS)[number]>;

export const USER_UPDATE_ALLOWED_KEYS = [...USER_CREATE_ALLOWED_KEYS] satisfies Array<keyof TableUpdateModel<'users'>>;

export type UserUpdateModel = Pick<TableUpdateModel<'users'>, (typeof USER_UPDATE_ALLOWED_KEYS)[number]>;
